export const HOME_PAGE = `/`;
export const BASE_PATH = `/mfrplogin`;
export const EXPIRED_PASSWORD_PATH = `${BASE_PATH}/expired-password/`;
export const EXPIRED_PASSWORD_PAGE = `${EXPIRED_PASSWORD_PATH}:username`;
export const FORGOT_PASSWORD_PAGE = `${BASE_PATH}/forgot-password`;
export const PASSWORD_CHANGED_PAGE = `${BASE_PATH}/password-changed`;
export const RESET_PASSWORD_PAGE = `${BASE_PATH}/reset-password/:token/:username`;
export const CREATE_PASSWORD_PAGE = `${BASE_PATH}/create-password/:token/:username`;
